<template>
  <v-select
    class="select-integration-list"
    label="text"
    :value="selectedValue"
    :options="options"
    :filterable="false"
    @open="onOpen"
    @close="onClose"
    @search="fetchOptions"
    @input="setSelected"
  >
    <template #spinner="{ loading }">
      <div
        v-if="loading"
        style="border-left-color: rgba(88, 151, 251, 0.71)"
        class="vs__spinner"
      >
        {{ $t("geral.loadingMoreData") }}
      </div>
    </template>
    <template #no-options>
      {{ $t('table.noRecord')  }}
    </template>
    <template #list-footer>
      <li v-show="hasNextPage" ref="load" class="loader">
        <!-- <base-spinner>
          <div class="ml-3">
            {{ $t("geral.loadingMoreData") }}
          </div>
        </base-spinner> -->
        <strong>{{ $t("geral.loadingMoreData") }}</strong>
      </li>
    </template>
  </v-select>
</template>

<script>
function debounce(func, delay) {
  let timerId;
  return function (...args) {
    clearTimeout(timerId);
    timerId = setTimeout(() => func.apply(this, args), delay);
  };
}

export default {
  components: {
    // BaseSpinner: () => import("@/components_rms/base/BaseSpinner.vue"),
  },
  props: {
    fieldId: String,
    value: String,
    selectedValue: Object,
  },
  data: () => ({
    currentPage: 1,
    perPage: 30,
    observer: null,
    options: [],
    search: "",
    hasNextPage: true,
  }),
  created() {
    this.currentPage = 1;
    this.options = [];
    this.getItems(null, "");
  },
  mounted() {
    /**
     * You could do this directly in data(), but since these docs
     * are server side rendered, IntersectionObserver doesn't exist
     * in that environment, so we need to do it in mounted() instead.
     */
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  methods: {
    async getItems(loading, searchQuery) {
      try {
        if (loading) {
          loading(true);
        }
        const response = await this.$apiWorkflow.get(
          `/field/values?currentPage=${this.currentPage}&perPage=${this.perPage}&fieldId=${this.fieldId}&stringQuery=${searchQuery}`
        );
        for (let opt of response.data) {
          this.options.push(opt);
        }
        this.hasNextPage = response.data.length >= this.perPage;
      } catch (error) {
        if (error.response.status == 401) {
          this.$store.dispatch("logout").then(() => {
            this.$router.push("/login");
          });
        } else {
          console.log(error);
        }
      } finally {
        if (loading) {
          loading(false);
        }
      }
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.currentPage++;
        await this.getItems(false, this.search);
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    setSelected(selectedValue) {
      this.$emit("update:selectedValue", selectedValue);
      if (selectedValue) {
        this.$emit("update:value", selectedValue.value);
      } else {
        this.$emit("update:value", null);
      }
    },
    onDebouncedSearch: debounce(function (loading, search, vm) {
      this.observer.disconnect();
      this.$nextTick().then(() => {
        this.currentPage = 1;
        this.options = [];
        this.hasNextPage = true;
        this.getItems(loading, search).then(() => {
          this.observer.observe(this.$refs.load);
        });
      });
    }, 500),
    fetchOptions(search, loading) {
      this.search = search;
      this.onDebouncedSearch(loading, search, this);
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
}
.pagination button:hover {
  cursor: pointer;
}
.select-integration-list {
  width: 100%;
}
.loader {
  text-align: center;
  color: #bbbbbb;
}


</style>